import { memo } from "react";
import { Typography } from "@mui/material";

const HexDisplay = ({ selectedPacket }) => {
  if (!selectedPacket) {
    return (
      <>
        <Typography variant="body2">
          00000000 30 31 31 32 33 34 35 36 37 38 39 40 41 | LAT:012344...
        </Typography>
        <Typography variant="body2">
          00000000 30 31 31 32 33 34 35 36 37 38 39 40 41 | **********...
        </Typography>
        <Typography variant="body2">
          00000000 30 31 31 32 33 34 35 36 37 38 39 40 41 | **********...
        </Typography>
      </>
    );
  }

  return (
    <>
      <Typography variant="body2">{selectedPacket.data[0]}</Typography>
      <Typography variant="body2">{selectedPacket.data[1]}</Typography>
      <Typography variant="body2">{selectedPacket.data[2]}</Typography>
    </>
  );
};

export default memo(HexDisplay);
